window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.article .twz-element-textwithmedia.twz-element-textwithmedia--video').forEach( e => {
        
        const firstP = e.querySelector('p:first-of-type');
        const match = window.matchMedia('(min-width: 768px)');
        if( firstP && match.matches) { 
            const offset = firstP.offsetTop;
            e.querySelector('.twz-element-textwithmedia__wrapper').style.marginTop = `${offset}px`;
        }
        
    })
});
